<template>
  <div class="box">
    <div class="text-center title">
      我们将下单及发货信息通过短信的形式发送给您，<span class="text-bold">请您留意短信</span>，有问题可以拨打客服电话：<span>{{servicePhone}}</span>
    </div>
    <div>
      <img class="pic" src="../assets/ok.png" alt="">
    </div>
    <div class="title">
      恭喜您订购成功
    </div>
    <div class="order">
      您的订单编号：<span>{{ orderNo }}</span>
    </div>
    <!-- <div @click="more" class="more">
      查看更多商品
    </div> -->
  </div>
</template>

<script>
  import { goGdtWx } from "../utils/api"
export default {
  name: 'ordersuccess',
  data () {
    return {
      orderNo:null,
      servicePhone:null,
      orderStay:null,
      wxlink:''
    }
  },
  created(){
    this.orderNo=this.$route.query.order_no
    this.servicePhone=this.$route.query.servicePhone
    this.orderStay=parseInt(this.$route.query.order_stay)
    // goGdtWx().then(res=>{
    //   console.log(res,"我的微信连接")
    // })
  },
  methods:{

  }
}
</script>
<style scoped>
.box{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  font-size: 20px;
  background: #f8f8f8;
}
.box div{
  margin-bottom: 20px;
}
.title{
  color:red;
  font-size: 22px;
}
.text-center{
  text-align: center;
}
.pic{
  width: 140px;
  margin-bottom: 40px;
}
.order{
  font-size: 18px;
}
.order span{
  color:red
}
.msg{
  font-size: 20px;
}
.msg span{
  color:red
}
.more{
  background:#00be2b ;
  font-size: 20px;
  padding:10px;
  color:white;
  border-radius:5px;
}
.text-bold{
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/orderResult.vue